export const DEFAULT_TEXT_CONFIG = {
  FORM_CREATE_NAME_DEFAULT: 'Новая форма',
  PLACEHOLDER_DEFAULT: 'Введите текст...',
  SAVE_BUTTON: 'Сохранить',
  SEND_BUTTON: 'Отправить',
  CANCEL_BUTTON: 'Отменить',
  CHANGE_BUTTON: 'Изменить',
  IMPORT_BUTTON: 'Импорт',
  FORM_BUTTON: 'Форма',
  CONTINUE_BUTTON: 'Продолжить',
  PASSWORD_INPUT: 'Пароль',
  EMAIL_INPUT: 'Email',
  EDIT_BUTTON: 'Редактировать',
  DELETE_BUTTON: 'Удалить',
  PUBLISH_BUTTON: 'Опубликовать',
  DICTIONARY_SETTINGS_TABLE: {
    ORDER: 'Порядок',
    LABEL: 'Название',
    BY_DEFAULT: 'По умолчанию',
  },
  SETUP_BUTTON: 'Настроить',
  INPUT: {
    ENTER_NAME: 'Введите название',
  },
  ALL_VALUES_MUST_BE_UNIQUE: 'Все значения должны быть уникальными',
  EXIT_BUTTON: 'Выйти',
};
